import { listAdminUsers } from '../../api/adminUsersApi';
import { adminListSupportTickets } from './adminTicketingFunctionsApi';

export function subscribeAdminUsers({ onData, onError }) {
  let cancelled = false;
  const load = async () => {
    try {
      const items = await listAdminUsers();
      if (!cancelled) onData(items);
    } catch (err) {
      if (onError) onError(err);
    }
  };
  void load();
  const interval = setInterval(() => {
    void load();
  }, 15000);
  return () => {
    cancelled = true;
    clearInterval(interval);
  };
}

export function subscribeAllSupportTickets({ pageSize = 50, status = 'all', onData, onError }) {
  let cancelled = false;
  const load = async () => {
    try {
      const items = await adminListSupportTickets({ status, pageSize });
      if (!cancelled) onData(items);
    } catch (err) {
      if (onError) onError(err);
    }
  };
  void load();
  const interval = setInterval(load, 20000);
  return () => {
    cancelled = true;
    clearInterval(interval);
  };
}
